import { ref, computed } from 'vue'
import { quotesService } from '../../services/quotesService.js'

/**
 * Détecte les impayés (formations terminées non réglées) de l'entreprise
 * rattachée à une demande de devis — rapprochement par SIRET puis email.
 */
export function useUnpaidDetection(quoteId) {
  const unpaid = ref(null)
  const loadingUnpaid = ref(false)

  const hasUnpaid = computed(() => (unpaid.value?.count || 0) > 0)

  const loadUnpaid = async () => {
    loadingUnpaid.value = true
    try {
      const data = await quotesService.getUnpaidHistory(quoteId)
      unpaid.value = data.unpaid || null
    } catch (err) {
      console.error('Erreur lors du chargement des impayés:', err)
      unpaid.value = null
    } finally {
      loadingUnpaid.value = false
    }
  }

  return {
    unpaid,
    loadingUnpaid,
    hasUnpaid,
    loadUnpaid
  }
}
